<template>
  <div>
    <h4><strong>Cartão de crédito</strong></h4>

    <div v-if="!cards.length" class="centralized-horizontal">
      <p class="centralized-horizontal-item">
        Não existem cartões para este aluno
      </p>
    </div>
    <div v-else>
      <table class="table table-striped">
        <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Bandeira</th>
            <th>Nome Titular</th>
            <th>Final</th>
            <th>Expiração</th>
            <th>Tipo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="card in cards" :key="card.id">
            <td>
              <input
                type="radio"
                :value="card"
                v-model="options.card"
                @change="$emit('change', options)"
              >
            </td>
            <td>{{ card.id }}</td>
            <td>{{ card.card_brand }}</td>
            <td>{{ card.holder_name }}</td>
            <td>{{ card.last_digits }}</td>
            <td>{{ card.expiration_month }}/{{ card.expiration_year }}</td>
            <td>{{ card.card_type | formatCardType }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      options: {
        card: null,
      },
    };
  },
  computed: {
    ...mapState([
      'studentCards',
    ]),
    cards() {
      return this.studentCards.filter(card => !card.deleted && card.card_type === 'credit_card');
    },
  },
};
</script>
